// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2mYUn","open":"open___1c6wW","container":"container___3SO-x","label":"label___2ZCLM"};